export const ACCESS_TOKEN = 'accessToken';

// route id, or the id for the backend server that this session routes to
export const RID = 'RID';

export const getNewTokenRequestBody = {
  is_guest: true,
  username: 'string',
  email: 'string',
  password: 'string',
};
